var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"payment-method-container"},[_c('v-row',[_c('v-col',[_c('strong',[_vm._v("Account Credit")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }